/* Lucino polish (v19): header scroll state and a shimmer while product photos load. */
(() => {
  const root = document.documentElement;

  // header gets a hairline shadow once the page has scrolled
  // (on desktop the theme scrolls .page-wrapper, not the window, so listen in the capture phase for both)
  const scrolled = () => Math.max(window.scrollY, document.querySelector('.page-wrapper')?.scrollTop || 0);
  const onScroll = () => root.classList.toggle('lx-scrolled', scrolled() > 8);
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  onScroll();

  // product photos: shimmer until loaded, then fade in
  const BOXES = '.lx14-piece__media, .card-gallery, .resource-card__media';
  const watch = (scope) => {
    for (const box of scope.querySelectorAll(BOXES)) {
      if (box.dataset.lxpWatched) continue;
      const img = box.querySelector('img');
      if (!img) continue;
      box.dataset.lxpWatched = '1';
      if (img.complete && img.naturalWidth > 0) continue;
      box.classList.add('lxp-wait');
      const done = () => {
        box.classList.remove('lxp-wait');
        box.classList.add('lxp-ready');
      };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    }
  };

  const start = () => {
    watch(document);
    // cards that arrive later (filters, recommendations, quick add, menu)
    new MutationObserver((records) => {
      for (const r of records) {
        for (const n of r.addedNodes) if (n.nodeType === 1) watch(n.matches?.(BOXES) ? n.parentNode || n : n);
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
